export class TOUDialog {
  tou: string;
  changed: boolean;
  isEnterprise: boolean;
}
